import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SaveIcon from "@mui/icons-material/Save";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import { getWithdrawLimitList } from "../../redux/actions/getWithdrawLimitListAction";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { addNewWithdrawLimit } from "../../redux/actions/addNewWithdrawLimitAction";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import EditIcon from "@mui/icons-material/Edit";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { Tooltip } from "antd";
// import Tooltip from "@mui/material/Tooltip";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const WithdrawLimit = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [currency, setCurrency] = useState("");
	const [level, setLevel] = useState("");
	const [page, setPage] = useState(0);
	const [open, setOpen] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [getWithdrawLimitStatus, setGetWithdrawLimitStatus] = useState(false);
	const [getWithdrawLimitResArray, setgetWithdrawLimitResArray] = useState([]);
	const [updatedWithdrawLimitStatus, setUpdatedWithdrawLimitStatus] =
		useState(false);
	const [updateWithdrawLimitPopup, setUpdateWithdrawLimitPopup] = useState("");
	const [limitId, setLimitId] = useState("");
	const [editCurrency, setEditCurrency] = useState("");
	const [editLevel, setEditLevel] = useState("");
	const [editDailyAmountLimit, setEditDailyAmountLimit] = useState("");
	const [editWeeklyAmountLimit, setEditWeeklyAmountLimit] = useState("");
	const [editMonthlyAmountLimit, setEditMonthlyAmountLimit] = useState("");
	const [editYearlyAmountLimit, setEditYearlyAmountLimit] = useState("");
	const [notificationOpen, setNotificationOpen] = React.useState(false);

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const classes = useStyles();
	const dispatch = useDispatch();

	const getWithdrawLimitRes = useSelector(
		({ getWithdrawLimitList }) => getWithdrawLimitList
	);

	const updateWithdrawLimitRes = useSelector(
		({ addNewWithdrawLimit }) => addNewWithdrawLimit
	);

	// console.log(
	// 	updateWithdrawLimitRes,
	// 	"////////////////////////////////////////////////////////"
	// );

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "currency") {
			setCurrency(value == "Select Currency" ? "" : value);
			// setCurrency(value);
		}

		if (name === "level") {
			// setLevel(value);
			setLevel(value == "Select Level" ? "" : value);
		}

		if (name === "EditCurrency") {
			setEditCurrency(value);
		}

		if (name === "EditLevel") {
			setEditLevel(value);
		}

		if (name === "EditDailyAmountLimit") {
			Util.verifyAmount(value)
				? setEditDailyAmountLimit(value)
				: setEditDailyAmountLimit(editDailyAmountLimit);
			// setEditDailyAmountLimit(value);
		}

		if (name === "EditWeeklyAmountLimit") {
			//setEditWeeklyAmountLimit(value);
			Util.verifyAmount(value)
				? setEditWeeklyAmountLimit(value)
				: setEditWeeklyAmountLimit(editWeeklyAmountLimit);
		}

		if (name === "EditMonthlyAmountLimit") {
			// setEditMonthlyAmountLimit(value);
			Util.verifyAmount(value)
				? setEditMonthlyAmountLimit(value)
				: setEditMonthlyAmountLimit(editMonthlyAmountLimit);
		}

		if (name === "EditYearlyAmountLimit") {
			//  setEditYearlyAmountLimit(value);
			Util.verifyAmount(value)
				? setEditYearlyAmountLimit(value)
				: setEditYearlyAmountLimit(editYearlyAmountLimit);
		}
	};

	const getWithdrawLimit = () => {
		setIsLoading(true);
		setGetWithdrawLimitStatus(true);
		const getWithdrawLimitReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				currency: currency,
				level: level
			}
		};

		return dispatch(getWithdrawLimitList(getWithdrawLimitReq, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getWithdrawLimit();
		}
	}, [regenerateTokenRes.data.status]);

	const getWithdrawLimitStatusFunc = () => {
		if (getWithdrawLimitStatus) {
			if (getWithdrawLimitRes.data.status == "success") {
				setIsLoading(false);
				setgetWithdrawLimitResArray(
					[].concat(
						getWithdrawLimitRes.data.customerMasterDetailsResponseVOList
					)
				);
			}
			if (getWithdrawLimitRes.data.status == "failed") {
				setIsLoading(false);
				setgetWithdrawLimitResArray(getWithdrawLimitRes.data);
				if (
					getWithdrawLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWithdrawLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}

			if (getWithdrawLimitRes.data.status == "Failed") {
				setIsLoading(false);
				setgetWithdrawLimitResArray(getWithdrawLimitRes.data);
				if (
					getWithdrawLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWithdrawLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getWithdrawLimitRes.data.status == "NOT FOUND") {
				setIsLoading(false);
				setgetWithdrawLimitResArray(getWithdrawLimitRes.data);
			}
		}
	};

	useEffect(() => {
		if (getWithdrawLimitRes.data.status == "success") {
			setPage(0);
		}
	}, [getWithdrawLimitRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const updateWithdrawLimitFunc = () => {
		setOpen(false);
		setUpdatedWithdrawLimitStatus(true);
		const addNewWithdrawLimitReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				currency: editCurrency,
				level: editLevel,
				dailyLimit: editDailyAmountLimit,
				weeklyLimit: editWeeklyAmountLimit,
				monthlyLimit: editMonthlyAmountLimit,
				yearlyLimit: editYearlyAmountLimit,
				limitId: limitId
			}
		};

		return dispatch(addNewWithdrawLimit(addNewWithdrawLimitReq, authToken));
	};

	const editWithdrawLimit = (
		limitId,
		customerName,
		level,
		daily,
		weekly,
		monthly,
		yearly
	) => {
		setLimitId(limitId);
		setEditCurrency(customerName);
		setEditLevel(level);
		setEditDailyAmountLimit(daily);
		setEditWeeklyAmountLimit(weekly);
		setEditMonthlyAmountLimit(monthly);
		setEditYearlyAmountLimit(yearly);
		setOpen(true);
	};

	useEffect(() => {
		if (getWithdrawLimitStatus) {
			getWithdrawLimitStatusFunc();
		}
	}, [getWithdrawLimitRes.data.status]);

	const updateWithdrawLimit = () => {
		if (updatedWithdrawLimitStatus) {
			if (updateWithdrawLimitRes.data.status == "success") {
				setOpen(false);
				setUpdateWithdrawLimitPopup(updateWithdrawLimitRes.data);
				setNotificationOpen(true);
				getWithdrawLimit();
			}
			if (updateWithdrawLimitRes.data.status == "failed") {
				setOpen(false);
				setUpdateWithdrawLimitPopup(updateWithdrawLimitRes.data);
				setNotificationOpen(true);
				if (
					updateWithdrawLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateWithdrawLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}

			if (updateWithdrawLimitRes.data.status == "Failed") {
				setOpen(false);
				setUpdateWithdrawLimitPopup(updateWithdrawLimitRes.data);
				setNotificationOpen(true);
				if (
					updateWithdrawLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateWithdrawLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		updateWithdrawLimit();
	}, [updateWithdrawLimitRes.data.status]);

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1rem",
							marginLeft: "1rem",
							gap: "16px"
						}}
					>
						<Grid item md={4} sm={12} lg={5}></Grid>
						<Grid item md={4} sm={12} lg={3}>
							<NavLink to="/index/WL-addwithdraw-limit">
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={getWithdrawLimit}
								>
									Add New Withdraw Limit
								</CustomButton>
							</NavLink>
						</Grid>
						<Grid item md={4} sm={12} lg={3} style={{ marginLeft: "1rem" }}>
							<NavLink to="/index/WL-addwithdrawal-count">
								{/* <Button
									variant="contained"
									style={{ backgroundColor: "#00b9f5", color: "white" }}
									size="small"
								>
									Add Withdrawal Count
								</Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={getWithdrawLimit}
								>
									Add Withdrawal Count
								</CustomButton>
							</NavLink>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item sm={12} md={4} lg={4}>
							<TextField
								select
								size="small"
								type="text"
								label="Currency"
								fullWidth={true}
								color="primary"
								variant="standard"
								autoFocus={true}
								name="currency"
								// value={currency || ""}
								defaultValue={"Select Currency" || currency}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{adminCurrencyList.success &&
									[]
										.concat(adminCurrencyList.data.currencyList)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>
						</Grid>
						<Grid item sm={12} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Level"
								variant="standard"

								fullWidth={true}
								name="level"
								// value={level || ""}
								defaultValue={"Select Level" || level}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Level" selected="Select Level">
									Select Level
								</MenuItem>
								<MenuItem value="Basic">BASIC</MenuItem>
								<MenuItem value="Standard">STANDARD</MenuItem>
								<MenuItem value="Premium">PREMIUM</MenuItem>
								<MenuItem value="Supreme">SUPREME</MenuItem>
							</TextField>
						</Grid>
						<Grid item sm={12} md={4} lg={4}>
							{/* <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                  marginTop: "9px",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={getWithdrawLimit}
              >
                Search
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getWithdrawLimit}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getWithdrawLimitResArray.length == undefined ||
				  !getWithdrawLimitStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText "
								>
									WithDraw Limit Details
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
									// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									WithDraw Limit Details
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											{/* <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Sr.No</TableCell> */}
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Currency
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Level
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Daily Amount Limit
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Weekly Amount Limit
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Monthly Amount Limit
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Yearly Amount Limit
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getWithdrawLimitResArray &&
											[]
												.concat(getWithdrawLimitResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={row.limitId}>
														{/* <TableCell align="center">{index + 1}</TableCell> */}
														<TableCell align="center">
															{row.customerName}
														</TableCell>
														<TableCell align="center">{row.level}</TableCell>
														<TableCell align="center">{row.daily}</TableCell>
														<TableCell align="center">{row.weekly}</TableCell>
														<TableCell align="center">{row.monthly}</TableCell>
														<TableCell align="center">{row.yearly}</TableCell>
														<TableCell align="center">
															<Tooltip title="Edit">
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		editWithdrawLimit(
																			row.limitId,
																			row.customerName,
																			row.level,
																			row.daily,
																			row.weekly,
																			row.monthly,
																			row.yearly
																		)
																	}
																>
																	{/* Update */}
																	{
																		<EditIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															</Tooltip>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getWithdrawLimitResArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
				<div>
					<Dialog open={open} onClose={handleClose}>
						<DialogTitle
							style={{ color: "#484848 !important" }}
							className="themeText"
						>
							Update Withdraw Limit
						</DialogTitle>
						<DialogContent>
							<TextField
								required
								style={{ marginTop: "10px" }}
								select
								size="small"
								// color="#484848"
								autoFocus={true}
								type="text"
								variant="standard"
								label="Currency"
								fullWidth={true}
								name="EditCurrency"
								value={editCurrency || ""}
								onChange={handleChange}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								{adminCurrencyList.success &&
									[]
										.concat(adminCurrencyList.data.currencyList)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								select
								size="small"
								// color="primary"
								variant="standard"

								autoFocus={true}
								type="text"
								label="Level"
								fullWidth={true}
								name="EditLevel"
								value={editLevel || ""}
								onChange={handleChange}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="">Select Level</MenuItem>
								<MenuItem value="Basic">BASIC</MenuItem>
								<MenuItem value="Standard">STANDARD</MenuItem>
								<MenuItem value="Premium">PREMIUM</MenuItem>
								<MenuItem value="Supreme">SUPREME</MenuItem>
							</TextField>

							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								// color="primary"
								autoFocus={true}
								variant="standard"
								
								type="text"
								label="Daily Amount Limit"
								value={editDailyAmountLimit || ""}
								name="EditDailyAmountLimit"
								fullWidth={true}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							></TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								// color="primary"
								autoFocus={true}
								variant="standard"

								type="text"
								label="Weekly Amount Limit"
								value={editWeeklyAmountLimit || ""}
								name="EditWeeklyAmountLimit"
								fullWidth={true}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							></TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								// color="primary"
								autoFocus={true}
								variant="standard"

								type="text"
								label="Monthly Amount Limit"
								value={editMonthlyAmountLimit || ""}
								name="EditMonthlyAmountLimit"
								fullWidth={true}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							></TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								// color="primary"
								variant="standard"

								autoFocus={true}
								type="text"
								label="Yearly Amount Limit"
								value={editYearlyAmountLimit || ""}
								name="EditYearlyAmountLimit"
								fullWidth={true}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							></TextField>
						</DialogContent>
						<DialogActions>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							{/* <Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={updateWithdrawLimitFunc}
							>
								Save
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={updateWithdrawLimitFunc}
								endIcon={<SaveIcon />}
							>
								Save <SaveIcon />
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>

			{updateWithdrawLimitPopup.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateWithdrawLimitPopup.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
								// endIcon={<SaveIcon />}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateWithdrawLimitPopup.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateWithdrawLimitPopup.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
								// endIcon={<SaveIcon />}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateWithdrawLimitPopup.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateWithdrawLimitPopup.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
								// endIcon={<SaveIcon />}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default WithdrawLimit;
